import { createVNode as _createVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"
import _imports_0 from '@/assets/img/detail-banner.png'
import _imports_1 from '@/assets/img/exchage-btn.png'


const _hoisted_1 = { class: "detail-wrapper" }
const _hoisted_2 = /*#__PURE__*/_createVNode("img", {
  class: "banner",
  src: _imports_0
}, null, -1)
const _hoisted_3 = { class: "number" }
const _hoisted_4 = { class: "info" }
const _hoisted_5 = { class: "name" }
const _hoisted_6 = { class: "desc" }
const _hoisted_7 = /*#__PURE__*/_createVNode("img", { src: _imports_1 }, null, -1)
const _hoisted_8 = { class: "rule" }
const _hoisted_9 = /*#__PURE__*/_createVNode("div", { class: "rule-title" }, "兑换规则", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InfoModal = _resolveComponent("InfoModal")
  const _component_FlopModal = _resolveComponent("FlopModal")
  const _component_RandomModal = _resolveComponent("RandomModal")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode("div", _hoisted_1, [
      _hoisted_2,
      _createVNode("div", _hoisted_3, _toDisplayString(_ctx.textCount.surplus), 1),
      _createVNode("div", _hoisted_4, [
        _createVNode("img", {
          class: "pic",
          src: _ctx.detail.img
        }, null, 8, ["src"]),
        _createVNode("div", _hoisted_5, _toDisplayString(_ctx.detail.title), 1),
        _createVNode("div", _hoisted_6, " 所需福字数量: " + _toDisplayString(_ctx.detail.number) + "个", 1),
        _createVNode("button", {
          class: "btn exchange-btn",
          disabled: _ctx.textCount.surplus < _ctx.detail.number,
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.exchangeClick()))
        }, [
          _hoisted_7
        ], 8, ["disabled"])
      ]),
      _createVNode("div", _hoisted_8, [
        _hoisted_9,
        _createVNode("div", {
          class: "rule-desc",
          innerHTML: _ctx.detail.intro || '暂无'
        }, null, 8, ["innerHTML"])
      ])
    ]),
    (_ctx.showInfoModal)
      ? (_openBlock(), _createBlock(_component_InfoModal, {
          key: 0,
          onClose: _ctx.closeInfo,
          onSubmit: _ctx.submitInfo
        }, null, 8, ["onClose", "onSubmit"]))
      : _createCommentVNode("", true),
    (_ctx.showFlopModal)
      ? (_openBlock(), _createBlock(_component_FlopModal, {
          key: 1,
          onClose: _cache[2] || (_cache[2] = ($event: any) => (_ctx.showFlopModal = false)),
          onOpen: _ctx.openClick,
          flopData: _ctx.modalData
        }, null, 8, ["onOpen", "flopData"]))
      : _createCommentVNode("", true),
    (_ctx.showRandomModal)
      ? (_openBlock(), _createBlock(_component_RandomModal, {
          key: 2,
          onClose: _cache[3] || (_cache[3] = ($event: any) => (_ctx.showRandomModal = false)),
          onOpen: _ctx.openClick,
          randomData: _ctx.modalData
        }, null, 8, ["onOpen", "randomData"]))
      : _createCommentVNode("", true)
  ], 64))
}